export enum TipoNivelUsuario{
    Precio_Comercial,
    Refacturacion
}